/* ================================================================
   WEBEXP-CORE.JS — Global Site Behavior
   Theme: WEBEXP v1.0.0
   Author: WEBEXP, LLC

   Handles: theme toggle, scroll-triggered animations,
   announcement bar dismiss, and site-wide utilities.
   ================================================================ */

(function () {
  'use strict';

  /* ================================================================
     1. DARK / LIGHT MODE TOGGLE
     ================================================================ */

  var THEME_KEY = 'webexp-theme';
  var root = document.documentElement;

  function getTheme() {
    return root.getAttribute('data-theme');
  }

  function setTheme(mode) {
    root.setAttribute('data-theme', mode);
    try { localStorage.setItem(THEME_KEY, mode); } catch (e) {}
  }

  /* Ensure data-theme is always set on load */
  if (!getTheme() || (getTheme() !== 'dark' && getTheme() !== 'light')) {
    try {
      var stored = localStorage.getItem(THEME_KEY);
      if (stored === 'dark' || stored === 'light') {
        setTheme(stored);
      } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
        setTheme('light');
      } else {
        setTheme('dark');
      }
    } catch (e) {
      setTheme('dark');
    }
  }

  /* Toggle button */
  var toggleBtn = document.getElementById('webexp-theme-toggle');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      setTheme(getTheme() === 'dark' ? 'light' : 'dark');
    });
  }


  /* ================================================================
     2. SCROLL-TRIGGERED FADE-UP ANIMATIONS
     ================================================================ */

  var fadeEls = document.querySelectorAll('.fade-up, .fade-in');

  if (fadeEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    fadeEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    /* Fallback: show everything if no IntersectionObserver */
    fadeEls.forEach(function (el) {
      el.classList.add('visible');
    });
  }


  /* ================================================================
     3. ANNOUNCEMENT BAR DISMISS
     ================================================================ */

  var announceBar = document.getElementById('webexp-announcement');
  var announceClose = document.getElementById('webexp-announcement-close');

  if (announceBar && announceClose) {
    var ANNOUNCE_KEY = 'webexp-announce-dismissed';

    /* Check if already dismissed */
    try {
      if (localStorage.getItem(ANNOUNCE_KEY) === 'true') {
        announceBar.style.display = 'none';
      }
    } catch (e) {}

    announceClose.addEventListener('click', function () {
      announceBar.style.display = 'none';
      try { localStorage.setItem(ANNOUNCE_KEY, 'true'); } catch (e) {}
    });
  }


  /* ================================================================
     4. STICKY HEADER SCROLL BEHAVIOR
     ================================================================ */

  var header = document.querySelector('.webexp-header');

  if (header) {
    var lastScrollY = 0;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.scrollY;

          /* Add scrolled state for styling (e.g. increased blur) */
          if (scrollY > 20) {
            header.classList.add('is-scrolled');
          } else {
            header.classList.remove('is-scrolled');
          }

          lastScrollY = scrollY;
          ticking = false;
        });
        ticking = true;
      }
    });
  }

})();